<script>
import FormModal from "@/components/form-modal.vue";
import MasterDetail from "@/components/master-detail.vue";
import HistoryListModal from "../shared/history-list-modal.vue";
import CreateParticipantModal from "../shared/create-participant-modal.vue";
import {
  TipoParticipante,
  TipoParticipanteLabel,
  PerfilHistoryColumns,
  BudgetKeyHistoryColumns,
  CentroCustoHistoryColumns
} from "../shared/participants";
import { mapGetters } from "vuex";

export default {
  components: {
    CreateParticipantModal,
    FormModal,
    MasterDetail,
    HistoryListModal
  },
  data() {
    return {
      profilesModal: {
        opened: false,
        profiles: []
      },
      budgetKeysModal: {
        opened: false,
        budgetKeys: []
      },
      profileColumns: PerfilHistoryColumns,
      budgetKeyColumns: BudgetKeyHistoryColumns,
      centroCustosModal: {
        opened: false,
        centroCustos: []
      },
      centroCustosColumns: CentroCustoHistoryColumns,
      opts: {
        bps: [],
        participants: [],
        centroCustos: [],
        tiposParticipante: [
          {
            id: TipoParticipante.COLABORADOR,
            label: TipoParticipanteLabel.COLABORADOR
          },
          {
            id: TipoParticipante.TERCEIRO,
            label: TipoParticipanteLabel.TERCEIRO
          },
          {
            id: TipoParticipante.VAGA_ABERTA,
            label: TipoParticipanteLabel.VAGA_ABERTA
          },
          {
            id: TipoParticipante.VAGA_NOVA,
            label: TipoParticipanteLabel.VAGA_NOVA
          }
        ]
      },
      selection: [],
      createModal: {
        opened: false,
        data: {}
      },
      tieModal: {
        error: "",
        opened: false,
        data: {}
      }
    };
  },
  computed: {
    ...mapGetters(["clientId"]),
    actionBarButtons() {
      return [
        {
          text: "Adicionar participante",
          icon: "mdi-account-plus-outline",
          action: () => {
            this.createModal.data = {
              tipo_participante: TipoParticipante.COLABORADOR
            };
            this.createModal.opened = true;
          }
        },
        // FEATURE DESCONTINUADA: o botão "Vincular participantes" foi ocultado.
        // O vínculo de participantes a um Business Plan agora é feito diretamente
        // na tela de Alocações (alocacao.vue), pelo botão "Vincular participantes"
        // presente no Business Plan. Mantido apenas como referência histórica.
        // {
        //   text: "Vincular participantes",
        //   icon: "mdi-link-variant-plus",
        //   action: async () => {
        //     await this.getBusinessPlans();
        //
        //     this.tieModal.data = {
        //       participants: this.selection.map(({ id }) => id)
        //     };
        //     this.tieModal.opened = true;
        //   }
        // }
      ];
    },
    cols() {
      return [
        {
          key: "tipo_participante",
          name: "Categoria",
          type: this.$fieldTypes.AUTOCOMPLETE,
          rel: { to: "tiposParticipante", key: "id", name: "label" },
          filterable: true
        },
        {
          key: "budget_key",
          name: "Budget Key",
          type: this.$fieldTypes.TEXT,
          tooltip: true,
          filterable: true
        },
        {
          key: "centro_custo_id",
          name: "Centro de custo",
          type: this.$fieldTypes.AUTOCOMPLETE,
          rel: { to: "centroCustos", key: "centro_custo_id", name: "centro_custo" },
          tooltip: true,
        },
        {
          key: "matricula",
          name: "Matrícula",
          type: this.$fieldTypes.TEXT,
          tooltip: true,
          filterable: true
        },
        {
          key: "nome",
          name: "Nome participante",
          type: this.$fieldTypes.TEXT,
          tooltip: true,
          filterable: true
        },
        {
          key: "email",
          name: "E-mail",
          type: this.$fieldTypes.TEXT,
          tooltip: true,
          filterable: true
        },
        {
          key: "senioridade",
          name: "Senioridade",
          type: this.$fieldTypes.TEXT
        },
        {
          key: "especialidade",
          name: "Especialidade",
          type: this.$fieldTypes.TEXT
        },
        {
          key: "papel_projeto",
          name: "Habilidades",
          type: this.$fieldTypes.TEXT,
          tooltip: true
        },
        {
          key: "formacao",
          name: "Formação técnica",
          type: this.$fieldTypes.TEXT,
          tooltip: true
        },
        {
          key: "button",
          name: "LinkedIn",
          type: this.$fieldTypes.HTML
        }
      ];
    },
    contextOptions() {
      return [
        {
          name: "Editar",
          hide: this.selection.length > 1,
          cb: row => {
            this.selection = [];
            this.createModal.data = {
              id: row.id,
              tipo_participante: row.tipo_participante,
              centro_custo_id: row.centro_custo_id,
              perfil_id: row.perfil_id,
              budget_key_id: row.budget_key_id,
              matricula: row.matricula,
              nome: row.nome,
              papel_projeto: row.papel_projeto,
              formacao: row.formacao,
              email: row.email,
              linkedin: row.linkedin,
              perfis: row.perfis,
              budget_keys: row.budget_keys,
              centro_custos: row.centro_custos
            };
            this.createModal.opened = true;
          }
        },
        {
          name: "Excluir",
          hide: this.selection.length > 1,
          cb: row => {
            if (this.$refs.masterDetail) {
              this.selection = [];
              this.$refs.masterDetail.selectedItem = { ...row };
              this.$refs.masterDetail.deleteDialog = true;
            }
          }
        },
        { name: "sep", hide: this.selection.length > 1 },
        {
          name: "Vincular a um Business Plan",
          cb: async row => {
            if (!this.selection.includes(row)) {
              this.selection.push(row);
            }

            await this.getBusinessPlans();

            this.tieModal.data = {
              participants: this.selection.map(({ id }) => id)
            };
            this.tieModal.opened = true;
          }
        },
        {
          name: "Histórico de Centros de Custo",
          cb: row => {
            this.centroCustosModal.centroCustos = row.centro_custos;
            this.centroCustosModal.opened = true;
          }
        },
        {
          name: "Histórico de Perfis",
          cb: row => {
            this.profilesModal.profiles = row.perfis;
            this.profilesModal.opened = true;
          }
        },
        {
          name: "Histórico de Budget Keys",
          cb: row => {
            this.budgetKeysModal.budgetKeys = row.budget_keys;
            this.budgetKeysModal.opened = true;
          }
        }
      ].filter(({ hide }) => !hide);
    },
    customResource() {
      const self = this;
      const resource = this.apiResource(
        `/v1/ativacaoped/${this.clientId}/participantes`
      );
      const opts = this.opts;
      return {
        ...resource,
        async get(...args) {
          let response = {};
          opts.participants = [];

          try {
            response = await resource.get(...args);
            const { data, error } = response;

            if (error) {
              throw error;
            }

            if (!Array.isArray(data)) {
              throw new Error("Data não encontrada");
            }

            response.data = data.map(
              ({
                budget_key,
                linkedin,
                perfil,
                tipo_participante,
                email,
                ...rest
              }) => ({
                ...rest,
                budget_key: budget_key?.posicao || "Sem BK",
                budget_key_id: budget_key?.id ?? null,
                especialidade: perfil?.especialidade,
                senioridade: perfil?.senioridade,
                email: email ?? "Não informado",
                perfil_id: perfil?.id,
                tipo_participante,
                linkedin
              })
            );
            opts.participants = response.data.map(participant => ({
              ...participant,
              label: `${participant.matricula ?? "Sem matricula"} — ${
                participant.nome ?? "Sem nome"
              }`
            })).sort(({ label: a }, { label: b }) => a.localeCompare(b));
          } catch (error) {
            self.notify(error);
            response.data = [];
            response.error = null;
          }

          return response;
        }
      };
    },
    tieFields() {
      return [
        {
          key: "participants",
          name: "Participantes",
          type: this.$fieldTypes.AUTOCOMPLETE_MULTIPLE,
          rel: { to: "participants", key: "id", name: "label" },
          rules: [{ rule: "required" }]
        },
        {
          key: "businessPlanId",
          name: "Business Plan",
          type: this.$fieldTypes.AUTOCOMPLETE,
          rel: { to: "bps", key: "id", name: "nome" },
          rules: [{ rule: "required" }]
        }
      ];
    }
  },
  created() {
    if (this.clientId === 0) {
      this.goToHome();
    } else {
      this.getCentroCusto();
    }
  },
  watch: {
    clientId(value) {
      if (value === 0) {
        this.goToHome();
        return;
      }

      // As opções são carregadas no `created`: na troca de empresa precisam
      // ser recarregadas para o cliente novo.
      this.getCentroCusto();
    }
  },
  methods: {
    confirmDeleteMessage({ matricula, nome, senioridade, especialidade }) {
      const reg = [matricula, nome, senioridade, especialidade]
        .filter(value => !!value)
        .join(" - ");
      return `Deseja excluir o registro: ${reg}?`;
    },
    async doExport() {
      try {
        const { get } = this.apiResource(
          `/v1/ativacaoped/${this.clientId}/participantes/export`
        );
        const response = await get();

        if (!response.url) {
          throw new Error();
        }

        const a = document.createElement("a");
        a.href = response.url;
        a.target = "_blank";
        a.click();
        a.remove();
      } catch {
        this.notify({
          message: "Não foi possível baixar o modelo. Tente novamente."
        });
      }
    },
    doImport() {
      this.$refs.inputFile?.click();
    },
    async doTieParticipants(values, closeFn) {
      try {
        const { businessPlanId, participants } = values;

        if (
          !businessPlanId ||
          !Array.isArray(participants) ||
          !participants.length
        ) {
          return;
        }

        this.tieModal.error = "";
        const { nome: bpName } = this.opts.bps.find(
          ({ id }) => businessPlanId === id
        );
        const resource = this.apiResource(
          `/v1/ativacaoped/${this.clientId}/business-plans/${businessPlanId}/participantes`
        );
        await resource.save({ participantes: participants });
        const { length } = participants;
        this.$notify({
          group: "geral",
          duration: 5000,
          type: "sucess",
          title:
            length > 1 ? "Participante vinculado" : "Participantes vinculados",
          text: `${length} participante${
            length > 1 ? "s foram" : " foi"
          } adicionado${length > 1 ? "s" : ""} ao BP ${bpName} com sucesso.`
        });
        this.selection = [];

        if (closeFn) {
          closeFn();
        }
      } catch (error) {
        this.tieModal.error = this.errorHandler(error);
      }
    },
    async getBusinessPlans() {
      try {
        this.opts.bps = [];
        const { get } = this.apiResource(
          `/v1/ativacaoped/${this.clientId}/business-plans/selecao`
        );
        this.opts.bps = await get();
      } catch {
        this.opts.bps = [];
      }
    },
    goToHome() {
      this.notify({
        error:
          "Não é possível acessar o módulo de Ativação P&D sem uma empresa selecionada."
      });
      this.$router.push({ name: "homepage" });
    },
    async doSave(data, close) {
      try {
        await this.customResource.save(data, data?.id);
        const isEditing = !!data?.id;
        const type =
          data?.tipo_participante in TipoParticipanteLabel
            ? TipoParticipanteLabel[data.tipo_participante]
            : "Participante";
        const perfilAtivo = (this.createModal.data.perfis || []).find(
          ({ id }) => id === data.perfil_id
        );
        const perfilLabel =
          perfilAtivo &&
          (perfilAtivo.senioridade || perfilAtivo.especialidade)
            ? perfilAtivo.senioridade && perfilAtivo.especialidade
              ? `${perfilAtivo.senioridade} | ${perfilAtivo.especialidade}`
              : perfilAtivo.senioridade || perfilAtivo.especialidade
            : null;
        const name = data.nome ?? perfilLabel ?? "Participante";
        const quantidade = data?.quantidade > 1 ? data.quantidade : 1;

        this.$notify({
          group: "geral",
          duration: 5000,
          type: "sucess",
          title: isEditing
            ? `${type} atualizado com sucesso`
            : quantidade > 1
            ? `${quantidade} vagas cadastradas com sucesso`
            : `${type} cadastrado com sucesso`,
          text: isEditing
            ? `${name} foi atualizado na lista de participantes da empresa.`
            : quantidade > 1
            ? `${quantidade} vagas de ${name} foram adicionadas a lista de participantes da empresa.`
            : `${name} foi adicionado a lista de participantes da empresa.`
        });
        setTimeout(() => this.$refs.masterDetail?.doLoad(), 1000);

        if (close) {
          close();
        }
      } catch (error) {
        if (!error.isAxiosError) {
          this.notify(error);
        }
      }
    },
    async onInputChange(event) {
      const [file] = Array.from(event.target.files);
      const MAX_FILE_SIZE = 10; // 10 MegaBytes

      if (file.size > MAX_FILE_SIZE * 1024 * 1024) {
        this.notify({
          error: `O arquivo ${file.name} excedeu o limite de ${MAX_FILE_SIZE}MB e não foi importado.`
        });
        return;
      }

      try {
        this.$root.$emit("addLoadingProcess", "participantesimport");
        const api = this.api();
        const url = `/v1/ativacaoped/${this.clientId}/business-plans/importar`;
        const formData = new FormData();
        formData.append("arquivo", file);
        formData.append("tipo", "participantes");

        await api.post(url, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        });

        this.$refs.masterDetail?.doLoad();

        this.$notify({
          group: "geral",
          duration: 5000,
          type: "sucess",
          title: "Importação concluída",
          text: `Dentro de instantes a lista de participantes será atualizada.`
        });
      } catch (error) {
        this.notify(error);
      } finally {
        this.$root.$emit("removeLoadingProcess", "participantesimport");
      }

      event.target.value = null; // Importante para poder voltar a anexar mais arquivos
    },
    async getCentroCusto() {
      try {
        this.opts.centroCustos = [];
        const { get } = this.apiResource(
          `/v1/ativacaoped/${this.clientId}/centros-de-custo/selecao`
        );
        const response = await get();
        this.opts.centroCustos = response.map(cc => {
          return {
            ...cc,
            centro_custo_id: cc.id,
            centro_custo: cc.nome
          };
        });
      } catch {
        this.opts.centroCustos = [];
      }
    }
  }
};
</script>

<template>
  <MasterDetail
    ref="masterDetail"
    :actionBarButtons="actionBarButtons"
    :canDelete="false"
    :canEdit="false"
    :confirmDeleteMessage="confirmDeleteMessage"
    :cols="cols"
    :contextOptions="contextOptions"
    :customResource="customResource"
    :hasExportCSV="false"
    :hasExportXLSX="false"
    :hasNewButton="false"
    :opts="opts"
    :selection.sync="selection"
    selectionCol
    serverPagination
  >
    <template #item.matricula="{ item }">
      <span>{{ item.matricula || "Sem matricula" }}</span>
    </template>

    <template #item.nome="{ item }">
      <span>{{ item.nome || "Sem nome" }}</span>
    </template>

    <template #item.button="{ item }">
      <a
        v-if="item.linkedin"
        :href="item.linkedin.includes('http') ? item.linkedin : `https://${item.linkedin}`"
        target="_blank"
      >
        <i
          class="v-icon notranslate mdi mdi-linkedin theme--light"
          style="color: #0e76a8"
        ></i>
      </a>
    </template>

    <!-- Modal de cadastro -->
    <CreateParticipantModal
      v-model="createModal.data"
      :opened.sync="createModal.opened"
      :centroCustos="opts.centroCustos"
      @save="doSave"
    />

    <!-- Modal de vinculo -->
    <FormModal
      :cols="tieFields"
      :errorMessage="tieModal.error"
      :opened.sync="tieModal.opened"
      :opts="opts"
      title="Vincular participantes a um Business Plan"
      :value.sync="tieModal.data"
      @save="doTieParticipants"
    />

    <!-- Modal de perfis -->
    <HistoryListModal
      v-model="profilesModal.opened"
      :data="profilesModal.profiles"
      title="Histórico de perfis"
      :columns="profileColumns"
    />

    <!-- Modal de histórico de Budget Keys -->
    <HistoryListModal
      v-model="budgetKeysModal.opened"
      :data="budgetKeysModal.budgetKeys"
      title="Histórico de Budget Keys"
      :columns="budgetKeyColumns"
    />

    <!-- Modal de histórico de Centros de Custo -->
    <HistoryListModal
      v-model="centroCustosModal.opened"
      :data="centroCustosModal.centroCustos"
      title="Histórico de Centros de Custo"
      :columns="centroCustosColumns"
    />

    <input
      ref="inputFile"
      accept=".xlsx"
      class="input-file"
      type="file"
      @change="onInputChange"
    />

    <div class="d-flex">
      <v-spacer></v-spacer>
      <div
        aria-label="exportButton"
        class="table-v-action-button mr-3 pt-1"
        @click="doExport()"
      >
        <v-icon>mdi-download-box-outline</v-icon> Exportar modelo
      </div>
      <div
        aria-label="importButton"
        class="table-v-action-button mr-3 pt-1"
        @click="doImport()"
      >
        <v-icon>mdi-upload-box-outline</v-icon> Importações
      </div>
    </div>
  </MasterDetail>
</template>

<style lang="scss" scoped>
.input-file {
  display: none;
}
</style>
